<template>
    <section class="project-step mgt-3 mgb-3">
        <div class="custom-container">
            <form id="form-step-2" class="step-form general-form">
                <input type="hidden" name="project" :value="project.id" />
                <div class="row project-heading-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="section-heading">
                            <i class="fad fa-layer-plus"></i>
                            <h1 class="m-color">
                                Adauga oferta - {{project.name}}
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-layer-group"></i>
                            </div>
                            <span> * Categorie Oferta </span>
                        </div>
                        <div class="row">
                            <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                <p class="custom-input-error" id="type_error"></p>
                                <div class="model-type-wrapper">
                                    <label class="box-radio-card">
                                        <input type="radio" name="type" value="apartment" class="card-input-element" v-model="modelCategory" />
                                        <div class="panel panel-default card-input">
                                            <i class="fad fa-building"></i>
                                            <h2 class="pannel-heading"> Apartament </h2>
                                        </div>
                                    </label>
                                    <label class="box-radio-card">
                                        <input type="radio" name="type" value="house" class="card-input-element" v-model="modelCategory" />
                                        <div class="panel panel-default card-input">
                                            <i class="fad fa-house"></i>
                                            <h2 class="pannel-heading"> Casa </h2>
                                        </div>
                                    </label>
                                    <label class="box-radio-card">
                                        <input type="radio" name="type" value="commercial" class="card-input-element" v-model="modelCategory" />
                                        <div class="panel panel-default card-input">
                                            <i class="fad fa-object-group"></i>
                                            <h2 class="pannel-heading"> Spatiu </h2>
                                        </div>
                                    </label>
                                </div>
                            </div> -->
                            <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="type" id="type_offer" v-model="modelCategory">
                                            <option v-for="category in modelCategories" :selected="category.selected" :disabled="category.disabled" :value="category.value" :key="category.id"> * {{category.name}} </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-sort-numeric-up-alt"></i>
                                        </div>
                                        <label class="custom-label" for="type_offer"> * Categorie oferta </label>
                                    </div>
                                </div>
                                <p class="custom-input-error" id="type_error"></p>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="flex-row align-items-end input-group mg-b">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">Tip</span>
                                        </div>
                                        <input type="text" id="model_type" name="model_type" value="" placeholder="Tip model">
                                        <label class="custom-label" for="model_type"> Tip model </label>
                                    </div>
                                    <p class="custom-input-error" id="model_type_error"></p>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                <div class="input-container" v-if="modelCategory != 'commercial'">
                                    <div class="input-group mg-b">
                                        <select name="rooms_count" id="rooms_count">
                                            <option selected="selected" disabled="disabled" value=""> * Nr. Camere </option>
                                            <option v-for="room in roomsCount" :value="room.id" :key="room.id"> {{room.name}} </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-sort-numeric-up-alt"></i>
                                        </div>
                                        <label class="custom-label" for="rooms_count"> * Nr. Camere </label>
                                    </div>
                                    <p class="custom-input-error" id="rooms_count_error"></p>
                                </div>
                            </div>
                        </div>
                        <div class="row project-step-row">
                            <div class="mt-4 col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="secondary-heading">
                                    <div class="secondary-heading-icon">
                                        <i class="fad fa-align-left"></i>
                                    </div>
                                    <span> Detalii despre model </span>
                                </div>
                                <div class="editor-wrapper">
                                    <vue-editor
                                        v-model="description"
                                        :editorOptions="{
                                        modules: {
                                            toolbar: [
                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                                [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                                ['clean'],
                                                [{ 'color': [] }, { 'background': [] }],
                                                ['link', 'image', 'video', 'emoji'],
                                            ],
                                            'emoji-toolbar': true,
                                            // 'emoji-textarea': true,
                                            'emoji-shortname': true,
                                        }
                                    }"/>
                                    <p class="custom-input-error" id="description_error"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-ruler-triangle"></i>
                            </div>
                            <span> Suprafata </span>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="useful-surface" name="useful_surface" value="" placeholder="* Suprafata totala (m²)">
                                        <div class="input-icon">
                                            <i class="fad fa-window-frame-open"></i>
                                        </div>
                                        <label class="custom-label" for="useful-surface"> * Suprafata totala(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="useful_surface_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="terrace-surface" name="terrace_surface" value="" placeholder="Suprafata balcon">
                                        <div class="input-icon">
                                            <i class="fad fa-window-frame-open"></i>
                                        </div>
                                        <label class="custom-label" for="terrace-surface"> Suprafata balcon(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="terrace_surface_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12" v-if="modelCategory === 'house'">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="garden-garden_surface" name="garden_surface" value="" placeholder="Suprafata teren">
                                        <div class="input-icon">
                                            <i class="fad fa-flower-daffodil"></i>
                                        </div>
                                        <label class="custom-label" for="garden-garden_surface"> Suprafata teren(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="garden_surface_error"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-2 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-tag"></i>
                            </div>
                            <span> Pret </span>
                        </div>
                        <div class="project-images-wrapper">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input type="number" id="model_price" name="price" value="" placeholder="* Pret Model">
                                            <div class="input-icon">
                                                <i class="fad fa-euro-sign"></i>
                                            </div>
                                            <label class="custom-label" for="model_price"> * Pret Model </label>
                                        </div>
                                        <p class="custom-input-error" id="price_error"></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-xl-8 col-md-12 col-12">
                                    <div class="price-addition-type row-flex">
                                        <label class="box-radio-card">
                                            <input type="radio" name="price_with_vat" class="card-input-element" value="0"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> +TVA </h2>
                                            </div>
                                        </label>
                                        <label class="box-radio-card">
                                            <input type="radio" name="price_with_vat" class="card-input-element" value="1"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> TVA Inclus </h2>
                                            </div>
                                        </label>
                                        <p class="custom-input-error" id="price_with_vat_error"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input type="number" id="model_credit_price" name="credit_price" value="" placeholder="Pret (cu credit)">
                                            <div class="input-icon">
                                                <i class="fad fa-euro-sign"></i>
                                            </div>
                                            <label class="custom-label" for="model_credit_price"> Pret (cu credit) </label>
                                        </div>
                                        <p class="custom-input-error" id="credit_price_error"></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-xl-8 col-md-12 col-12">
                                    <div class="price-addition-type row-flex">
                                        <label class="box-radio-card">
                                            <input type="radio" name="credit_price_with_vat" class="card-input-element" value="0"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> +TVA </h2>
                                            </div>
                                        </label>
                                        <label class="box-radio-card">
                                            <input type="radio" name="credit_price_with_vat" class="card-input-element" value="1"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> TVA Inclus </h2>
                                            </div>
                                        </label>
                                        <p class="custom-input-error" id="credit_price_with_vat_error"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="general-check step-check">
                                        <input type="checkbox" name="show_payment_methods" value="1" id="payment_type_show" class="custom-checkbox">
                                        <label for="payment_type_show" class="custom-checkbox-label">
                                            <span></span>
                                            <p>
                                                Afiseaza modalitatea de plata
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-images"></i>
                            </div>
                            <span> Imagini Model </span>
                        </div>

                        <div class="project-images-wrapper">
                            <p class="custom-input-error" :id="`ungroupedImages-${index}_error`" v-for="(img, index) in ungroupedImages" :key="`ung-${index}`"></p>
                            <div class="row">
                                <div class="col-12">
                                    <div class="images-group-uploader">
                                        <input type="file" name="groupImages" id="groupImages" multiple
                                               @change="onMultipleFileChange">
                                        <label for="groupImages" class="general-btn positive-btn">
                                        <span> Incarca imagini </span>
                                            <i class="fad fa-upload"></i>
                                        </label>
                                    </div>
                                    <draggable :forceFallback="true" v-if="ungroupedImages" class="images-group card-columns model"
                                               :list="ungroupedImages" group="picsGroup">
                                        <div v-for="(image, index, key) in ungroupedImages" :key="key"
                                             class="group-uploaded-img card">
                                            <img :src="image.base64" @click="triggerImg"/>
                                            <div class="clear-post-img" @click="removeUngroupImage(index)">
                                                <i class="fad fa-trash-alt"></i>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-video"></i>
                            </div>
                            <span> Link Video Model (doar linkuri Youtube) </span>
                        </div>
                        <div class="video-links-wrapper">
                            <div class="row">
                                <div class="mb-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" v-for="(videoRow, index) in videoRows" :key="index">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input v-model="videoRow.url" placeholder="Link Video" type="text"
                                                   name="video[]">
                                            <div class="input-icon">
                                                <i class="fad fa-video"></i>
                                            </div>
                                            <label class="custom-label sr-only"> Link Video </label>
                                        </div>
                                        <span class="floating-remove-el" @click="removeModelVideoElement(index)">
                                            <i class="fad fa-times-circle"></i>
                                        </span>
                                        <p class="custom-input-error" :id="`video-${index}_error`"></p>
                                    </div>
                                    <linkPrevue :url="videoRow.url">
                                        <template slot-scope="props">
                                            <div class="prevue-card">
                                                <a v-bind:href="props.url" target="_blank"
                                                   class="general-btn positive-btn prevue-viewmore-btn">
                                                    <span> Vezi link </span>
                                                    <i class="fad fa-eye"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </linkPrevue>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div class="mt-3 center-content save-btn">
                                        <p class="general-btn positive-btn" @click="addModelVideoRow()">
                                            <i class="fad fa-video-plus"></i>
                                            <span> Adauga link </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row" style="position: relative;">
                    <div class="mt-3 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="general-check step-check">
                            <input type="checkbox" name="publish_model" class="custom-checkbox" checked>
                            <label for="publish_model" class="custom-checkbox-label">
                                <span></span>
                                <p>
                                    Publica modelul in platforma
                                    <span class="item-action-btn"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Pentru a fi publicat trebuie sa fie adaugata cel putin o oferta valabila sau vanduta in disponibilitati.">
                                        <i class="fad fa-info-circle"></i>
                                    </span>
                                </p>
                                <p style="color:red;">&nbsp;Pentru a fi publicat trebuie sa fie adaugata cel putin o oferta vanduta sau disponibila la disponibilitati.</p>
                            </label>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="mt-3 center-content save-btn">
                            <button type="submit" class="general-btn positive-btn">
                                <span> Salveaza </span>
                                <i class="fad fa-save"></i>
                            </button>
                            <button type="button" class="general-btn positive-btn" @click="save(true)">
                                <span> Salveaza si adauga disponibilitati </span>
                                <i class="fad fa-long-arrow-alt-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="section-loading-screen" v-if="showLoading">
                        <div class="section-loading-bubbles">
                            <span class="d1"></span>
                            <span class="d2"></span>
                            <span class="d3"></span>
                            <span class="d4"></span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div id="fullscreen-preview" class="fullscreen-img" :class="{'fullscreen-img-active' : fullScreen}">
            <!-- :style="{backgroundImage: `url(${src})`}" -->
            <div class="fullscreen-container" v-if="fullScreenScr">
                <img :src="fullScreenScr" alt="">
            </div>
            <div class="close-element" @click="fullScreen = !fullScreen">
                <i class="fad fa-times-circle"></i>
            </div>
        </div>
    </section>
</template>

<script>
  import draggable from 'vuedraggable'
  import linkPrevue from 'link-prevue'
  import { VueEditor, Quill } from "vue2-editor";
  import Emoji from "quill-emoji/dist/quill-emoji";

  Quill.register("modules/emoji", Emoji);

  export default {
    name: "AddProjectStep2",
    props: ['project','roomsCount'],
    components: {
      draggable,
      linkPrevue,
      VueEditor
    },
    data() {
      return {
        editor: null,
        showLoading: false,
        description: '',
        videoRows: [],
        ungroupedImages: [],
        files: [],
        modelCategory: '',
        modelCategories: [
            {
                id: '',
                name: 'Categorie Oferta',
                value: '',
                selected: true,
                disabled: true
            },
            {
                id: 1,
                name: 'Apartamente',
                value: 'apartment',
                selected: '',
                disabled: false
            },
            {
                id: 2,
                name: 'Case',
                value: 'house',
                selected: '',
                disabled: false
            },
            {
                id: 3,
                name: 'Spaţii Comerciale',
                value: 'commercial',
                selected: '',
                disabled: false
            },
        ],
        fullScreenScr: '',
        fullScreen: false,
      }
    },
    mounted() {
      let vm = this;
      $('#form-step-2').submit(function(e){
        e.preventDefault();
        vm.save(false);
      })
      let qParams = window.getAllUrlParams(window.location.href)
      if (qParams.type) {
        switch (qParams.type) {
          case 'apartment':
            this.modelCategory = 'apartment'
            break;

          case 'house':
            this.modelCategory = 'house'
            break;

          case 'commercial':
            this.modelCategory = 'commercial'
            break;
        }
      }
    },
    methods: {
      addModelVideoRow: function() {
         this.videoRows.push({
             url: ''
         });
      },
      removeModelVideoElement: function(index) {
        if ((index < 1) && (this.videoRows.length < 2)) {
            this.videoRows[0].url = '';
            return;
        }
        this.videoRows.splice(index, 1);
      },
      handleClone(item) {
        // Create a fresh copy of item
        let cloneMe = JSON.parse(JSON.stringify(item));
        this.$delete(cloneMe, 'uid');
        return cloneMe;
      },
      onFileChange(e) {
        const file = e.target.files[0];
        this.url = URL.createObjectURL(file);
        this.image = this.$refs.image.files[0];
      },
      clearPostImage() {
        this.url = null;
        this.image = '';
      },

      onMultipleFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.createImage(files);
      },
      createImage(files) {
        let vm = this;
        for (let index = 0; index < files.length; index++) {
          let reader = new FileReader();
          reader.onload = function (event) {
            const groupImageUrl = {base64: event.target.result};
            vm.ungroupedImages.push(groupImageUrl);
          }
          reader.readAsDataURL(files[index]);
        }
      },
      removeUngroupImage(index) {
        this.ungroupedImages.splice(index, 1)
      },
      triggerImg: function (img) {
        this.fullScreenScr = img.srcElement.src;
        this.fullScreen = !this.fullScreen
      },
      save(redirectNextStep) {
        window.resetErrors()
        let vm = this;
        vm.showLoading = true;
        let myForm = document.getElementById('form-step-2');
        let formData = new FormData(myForm);
        formData.append('ungroupedImages', JSON.stringify(this.ungroupedImages));
        if(this.description != null) {
          formData.append('description', this.description);
        }
        window.axios.post(`/developer/${this.project.id}/add-project-step2`,formData)
          .then(function (response) {
            vm.showLoading = false;
            window.Swal.fire({
              html: 'Modelul a fost adaugat cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
                if(redirectNextStep) {
                  window.location.href = `/developer/${response.data.data.project_id}/${response.data.data.id}/add-project-step3`
                } else {
                  if (formData.get('type') === 'commercial') {
                    window.location.href = `/developer/project/${response.data.data.project_id}?tab=space`
                  } else if (formData.get('type') === 'house') {
                    window.location.href = `/developer/project/${response.data.data.project_id}?tab=house`
                  } else {
                    window.location.href = `/developer/project/${response.data.data.project_id}?tab=apartment`
                  }
                }
            })
          })
          .catch(function (err) {
            vm.showLoading = false;
            vm.buttonDisable = false;
            window.showError(err)
          });
      }
    }
  }
</script>
